export default {"src":"/_next/static/media/health-insurance.4e27584f.svg","height":209,"width":346,"blurWidth":0,"blurHeight":0};